export default "__VITE_ASSET__CFyV394v__"